import { T_Branch, T_Major } from "../definition/ModulePropTypes";

export const _PermittedSetting = (setting, path) => {
  let v = null;
  let inPermission = setting;

  if (Array.isArray(path)) {
    let i = 0;
    while (i < path.length) {
      let module = path[i];
      if (i === 0 || module.type === T_Major) {
        inPermission = setting;
        inPermission = inPermission.find((v) => v.id === module.id);
      } else if (module.type === T_Branch) {
        // console.log(path[i], inPermission[module.id]);
        inPermission =
          inPermission && inPermission[module.id]
            ? inPermission[module.id]
            : null;
      } else {
        inPermission =
          inPermission && inPermission[module.id]
            ? inPermission[module.id].v
            : null;
      }

      v = inPermission;
      i++;
      if (v === null) break;
    }
  } else {
    inPermission = setting;
    v = (inPermission.find((v) => v.id === path.id) || {v : null}).v;

  }

  return v;
};
